import EnhancedFilterForm from './EnhancedFilterForm';

/**
 * Left rail for Filter Students v2. Changes search as they are made.
 */
const FilterSidebar = ({ filters, onChange, onSubmit, loading, token }) => (
  <aside
    className="rounded-lg border p-3 lg:sticky lg:top-4 lg:max-h-[calc(100vh-6rem)] lg:overflow-y-auto"
    style={{
      borderColor: 'var(--staff-line, #c9d5e5)',
      backgroundColor: 'var(--staff-surface, #fff)',
    }}
  >
    <h2 className="text-sm font-semibold mb-3" style={{ color: 'var(--staff-navy, #0e2443)' }}>
      Filters
    </h2>
    <EnhancedFilterForm
      filters={filters}
      onChange={onChange}
      onSubmit={onSubmit}
      loading={loading}
      token={token}
      compact
      autoApply
    />
  </aside>
);

export default FilterSidebar;
